import { useNavigate } from 'react-router-dom'
import styles from './HiddenDetailBox.module.less'
import { PAGE_LINKS } from '@/router/pageConst'
import { commonUtils } from '@/helpers/commonUtils'
import { useTranslation } from 'react-i18next'
import MiddleText from '@/components/MiddleText/MiddleText'

function HiddenDetailBox() {
  const navigate = useNavigate()
  const { t } = useTranslation()
  return <div className={styles.hiddenDetailBox}>
    <img className={styles.bg} src={commonUtils.getImagePath('projectDetailPage/hidden-detail-bg.png')} alt="" />
    <div className={styles.content}>
      <p className={styles.desc1}>{t('modals.freeTrialModal.hiddenBoxText1')}</p>
      <p className={styles.desc2}>{t('modals.freeTrialModal.hiddenBoxText2')}</p>
      <button className={styles.btn} onClick={() => {
        navigate(PAGE_LINKS.pricing)
      }}>
        <span>🚀</span>
        <MiddleText text={t('modals.freeTrialModal.hiddenBoxBtn')}></MiddleText>
      </button>
    </div>
  </div>
}

export default HiddenDetailBox